var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editorQrCodeElement",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":("editorQrCodeElement-" + (_vm.el.id))}},[_c('img',{attrs:{"src":_vm.qrPlaceholder}})])}
var staticRenderFns = []

export { render, staticRenderFns }